"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBiToken = exports.getInstanceId = exports.getVisitorId = void 0;
exports.getInstanceValue = getInstanceValue;
exports.getRandomGuid4 = getRandomGuid4;
var queryParams_1 = require("./queryParams/queryParams");
exports.getVisitorId = globalMemoize('getVisitorId', function () {
    return (getInstanceValue('uid') || // userId
        getInstanceValue('aid') || // aid is anonymous user id
        getRandomGuid4());
});
exports.getInstanceId = globalMemoize('getInstanceId', function () {
    return getInstanceValue('instanceId') || getRandomGuid4();
});
exports.getBiToken = globalMemoize('getBiToken', function () {
    var biToken = getInstanceValue('biToken');
    if (biToken) {
        return biToken;
    }
    return getRandomGuid4();
});
var getInstance = globalMemoize('getInstance', function () {
    try {
        var instanceKVP = (0, queryParams_1.getQueryParams)().instance;
        if (instanceKVP) {
            var instanceEncoded = instanceKVP.split('.')[1];
            return JSON.parse(atob(instanceEncoded));
        }
    }
    catch (ex) {
        console.warn('Cannot get instance'); // tslint:disable-line:no-console
    }
    return {};
});
function getInstanceValue(key) {
    return getInstance()[key];
}
function globalMemoize(memoizationKey, fn) {
    if (!window.memoizedWixUtils) {
        Object.defineProperty(window, 'memoizedWixUtils', { value: {} });
    }
    if (!window.memoizedWixUtils[memoizationKey]) {
        var memoized_1 = {};
        window.memoizedWixUtils[memoizationKey] = function (key) {
            if (!memoized_1[key]) {
                memoized_1[key] = fn.apply(this, arguments);
            }
            return memoized_1[key];
        };
    }
    return window.memoizedWixUtils[memoizationKey];
}
function getRandomGuid4() {
    // tslint:disable:no-bitwise
    //generate fake guid starting on badabada
    return 'badabada-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line
        var r = (Math.random() * 16) | 0, v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
//# sourceMappingURL=wix-utils.js.map